enum PfmSpendingStatus {
  NO_ACTION = 'NO_ACTION',
  OPTED_IN = 'OPTED_IN',
  OPTED_OUT = 'OPTED_OUT',
}

export default PfmSpendingStatus;
